export const globalConfig = {
  apiBaseURL: 'https://origohealth-usa.gazelleplatform.com/services/',
  apiMainBaseURL: 'https://origohealth-usa.gazelleplatform.com/services/security',
  apiDatahubBaseURL:
    'https://origohealth-usa.gazelleplatform.com/services/security/api-proxy-service',
  apiDiagnosticBaseURL:
    'https://origohealth-usa.gazelleplatform.com/services/diagnostics',
  apiServicesUrl: 'https://origohealth-usa.gazelleplatform.com/services/api/',
  securityServicesUrl:
    'https://origohealth-usa.gazelleplatform.com/services/security/',
  sharedServicesUrl:
    'https://origohealth-usa.gazelleplatform.com/services/security/',
  apiPublicURL: 'https://api.gazelleplatform.com',
  loginUrl: 'https://app.origohealth.net',
  datahubHost: 'datahub.gazelleplatform.com',
  logoutUrl:
    'https://origohealth-us.us.auth0.com/v2/logout?client_id=G6aLDiC1LVbyzkkSdCo7NSkICkQXcIlq&returnTo=https://www.origohealth.net',
  authUri:
    'https://origohealth-us.us.auth0.com/authorize?response_type=code&client_id=G6aLDiC1LVbyzkkSdCo7NSkICkQXcIlq&redirect_uri=https://origohealth-usa.gazelleplatform.com/callback&scope=openid%20profile%20email&state=S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  targetUrl: 'https://origohealth-usa.gazelleplatform.com/',
  userinfoUrl: 'https://origohealth-us.us.auth0.com/userinfo',
  neoUrl: "https://neo-origohealth.netlify.app",
  dynamoUrl: "https://dynamo-origohealth.netlify.app",
  breezeUrl: "https://breeze-origohealth.netlify.app",
  state:
    'S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  platformWelcomeMessage: 'Welcome to the digital convergence experience',
  ehxClaimsTopicName: 'gazelle.ehx.claims.queue',
  ehxClaimsServer: 'amqp://192.168.192.6',
  bearerTokenValue:
    'B234A23N4S235A52SD35B34S6Z5K7L56FA87D69L79FK879A6S57F436K2JB42K34JS234FB2S3A423H4JF34B6K45A6S45F7B5K67A5S8J8D68F5H65S76A58F',
  userInfoUrl: 'https://origohealth-us.us.auth0.com/userinfo',
  developmentUrl: 'http://localhost:3011',
  paginationLimit: 5,
  googleMapsApi: 'AIzaSyCeNLUmMgY8Nw1aYy9jjyswHwrcK5p_dOg',
  auth0: {
    domain: 'origohealth-us.us.auth0.com',
    clientId: 'G6aLDiC1LVbyzkkSdCo7NSkICkQXcIlq',
    managementAPIUrl: 'https://origohealth-us.us.auth0.com/api/v2/'
  },
  OPENTOK_URL: 'https://tokbox.com/embed/embed/ot-embed.js?',
  MAP_BOX_ACCESS_TOKEN:
    'pk.eyJ1Ijoib3JpZ29zb2Z0d2FyZSIsImEiOiJja2lkZXAyOTUwa2hpMnhwZXphcDEwYnBlIn0.bL_Xsmn35OU6bbpI9o84vQ',
  defaultFacilityId: 3597,
  defaultProviderId: 1,
  twilio: {
	messagingServiceSid : "MG6db97adf094eab87ba3d4656bd7c6259",
    contentSid : "HXfaa0bc60af3ba7136b108ff26c9fd1bb",
    whatsAppChannelNumber : "+18453799458",
	},
  serviceAccessToken: "linkedin|rz1MycKLaZ:520",
  cloudName: 'ORIGOHEALTH'
}
